module.exports = __webpack_public_path__ + "img/chrome-tune.d5db8a5e.png";